import type { Option, OptionWithDisplayName } from '../../types/types';
import Button from '../button/button';
import styles from './variant-selector.module.scss';

interface Props {
  option: Option;
  onOptionChange: (option: Option, value: string) => void;
  selected: string | null;
  disabled?: boolean;
  /** Values that can't be selected, e.g. sold out sizes. */
  unavailableValues?: string[];
  showLabel?: boolean;
}

export default function VariantSelector({
  option,
  onOptionChange,
  selected,
  disabled = false,
  unavailableValues = [],
  showLabel = true
}: Props) {
  return (
    <>
      {showLabel && (
        <div className={styles.optionName}>
          {(option as OptionWithDisplayName).displayName || option.name}
        </div>
      )}
      <div className={styles.optionValues}>
        {option.values.map(value => {
          const isUnavailable = unavailableValues.includes(value);

          return (
            <Button
              variant="secondary"
              className={`${styles.optionValue} ${selected === value ? styles.active : ''} ${isUnavailable ? styles.unavailable : ''}`}
              key={`${option.name}-${value}`}
              onClick={() => onOptionChange(option, value)}
              disabled={disabled || isUnavailable}
              title={isUnavailable ? 'Nincs készleten' : undefined}
            >
              {value}
            </Button>
          );
        })}
      </div>
    </>
  );
}
